export default __webpack_public_path__ + "static/2-4e1d064c7561c79c6739ba32e45b2ee9.jpg";